export const getValletTransactionsRoute = () => {
    return '/vallet-transactions';
};

export const GET_TRANSACTION_DATA = '/opsDashboard/customerWallet/fetchUploadedWalletTransactions';
export const UPLOAD_TRANSACTION_DATA = '/opsDashboard/customerWallet/uploadBulkWalletTransactions';
export const GET_SAMPLE_EXCEL = '/opsDashboard/customerWallet/downloadSampleExcel';
export const PROCESS_TRANSACTION_DATA = '/opsDashboard/customerWallet/processWalletTransactions';
export const FETCH_FINANCE_ACTIONS = '/CRMDashboard/finance/actions/fetch';
